// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyAgbTRUY0GyshM08iVopfJZG28J9IXsKps",
  authDomain: "smartevacauth.firebaseapp.com",
  projectId: "smartevacauth",
  storageBucket: "smartevacauth.firebasestorage.app",
  messagingSenderId: "547641864093",
  appId: "1:547641864093:web:99b6d67861c2d814164974"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const auth = getAuth(app);

export {app, auth};